;(function () {
  angular
    .module('contrast.tsv')
    .controller('OrganizationalTsvCtrl', OrganizationalTsvCtrl)

  function OrganizationalTsvCtrl(
    $scope,
    $q,
    dialogs,
    logger,
    preferencesService,
    tsvApiConfig,
    ErrorService,
    PREFERENCE_PROPERTIES
  ) {
    'ngInject'

    angular.extend($scope, {
      tsv: {},
      system_tsv: {}
    })

    angular.extend($scope, {
      save: save
    })

    function init() {
      $scope.promises = []
      $scope.promises.push(getOverrideSystemTsv())
      $scope.promises.push(getEnabledSystemTsv())
      $scope.promises.push(getOrganizationTsv())

      $q.all($scope.promises).then(function () {
        if (!$scope.system_tsv.override) {
          $scope.tsv.enabled = $scope.system_tsv.enabled
          $scope.tsv.required = true
        }
      })
    }

    function getOverrideSystemTsv() {
      return preferencesService
        .getBooleanValue(PREFERENCE_PROPERTIES.TSV_ENABLED_OVERRIDE)
        .then(function (preferenceValue) {
          $scope.system_tsv.override = preferenceValue
        })
    }

    function getEnabledSystemTsv() {
      return preferencesService
        .getBooleanValue(PREFERENCE_PROPERTIES.TSV_ENABLED)
        .then(function (preferenceValue) {
          $scope.system_tsv.enabled = preferenceValue
        })
    }

    function getOrganizationTsv() {
      return tsvApiConfig
        .getOrganizationTsv()
        .then(function (response) {
          var data = response.data
          $scope.tsv.enabled = data.tsv.enabled
          $scope.tsv.required = data.tsv.required
        })
        .catch(ErrorService.processError)
    }

    function save() {
      var msg =
        'You are about to override the default Multi-Factor Authentication settings for this organization. Do you still want to proceed?'
      dialogs
        .confirm('Please Confirm', msg, { size: 'sm' })
        .result.then(function () {
          update()
          logger.logSuccess('your changes were saved.')
        })
    }

    function update() {
      tsvApiConfig
        .updateOrganizationTsv($scope.tsv)
        .then(function () {
          logger.logSuccess('Your changes were saved.')
        })
        .catch(ErrorService.processError)
    }

    init()
  }
})()
